<table *ngIf="examStats && examStats.length > 0" mat-table [dataSource]="examStats"
       class="mat-elevation-z2 full-width results-table">

  <!-- Grade Column -->
  <ng-container matColumnDef="grade">
    <th mat-header-cell *matHeaderCellDef>
      <span
        i18n="Stats Dashboard|Exam Card Stats exam grade title@@stats-dashboard-exam-card-exam-grade-title">Result:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="grade mat-body-2">
            <span *ngIf="element.grade || element.type == statsTypes.user_part"
                  [class.color-green]="element.grade == examGrades.excellent"
                  [class.color-orange]="element.grade == examGrades.good">{{localizeExamGrade(element.grade || examGrades.average)}}</span>
      <mat-icon *ngIf="!element.grade && element.type != statsTypes.user_part"
                matTooltip="count in progress"
                i18n-matTooltip="Stats Dashboard|Exam stats not ready title@@stats-dashboard-exam-stats-not-ready-title"
                class="color-orange">loop
      </mat-icon>
    </td>
  </ng-container>

  <!-- User Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      <span i18n="Users List|Users List item 'name' title@@users-list-item-name-title">Name:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="user-name">
      <a *ngIf="showAnswerSheets && canSeeExamCard(element);else otherUser"
         [routerLink]="getExamCardUrl(element)"
         target="_blank">
        {{element.firstName}} {{element.lastName}}
      </a>
      <ng-template #otherUser>
        {{element.firstName}} {{element.lastName}}
      </ng-template>
    </td>
  </ng-container>

  <!-- Email Column -->
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>
      <span i18n="Users List|Users List item 'email' title@@users-list-item-email-title">Email:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="email mat-small word-wrap">
      {{element.email}}
    </td>
  </ng-container>

  <!-- School Grade Column -->
  <ng-container matColumnDef="school_grade">
    <th mat-header-cell *matHeaderCellDef>
            <span i18n="School details|School grade@@school-details-grade-sub-title">
              School grade:
            </span>
    </th>
    <td mat-cell *matCellDef="let element" class="school-grade">
      {{element.schoolGrade}}
      <span *ngIf="!!element.taskType && element.taskType != taskTypes.standard" class="mat-small text-disabled-color">
        ({{localizeTaskType(element.taskType)}})
      </span>
    </td>
  </ng-container>

  <!-- Region Column -->
  <ng-container matColumnDef="region">
    <th mat-header-cell *matHeaderCellDef>
      <span i18n="Users List|Users List item 'region' title@@users-list-item-region-title">Region:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="region-name">
      {{regions.get(element.regionId)}}
    </td>
  </ng-container>

  <!-- School Name Column -->
  <ng-container matColumnDef="school_name">
    <th mat-header-cell *matHeaderCellDef>
      <span i18n="Users List|Users List item 'school' title@@users-list-item-school-title">School:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="school-name">
      {{element.schoolName}}
    </td>
  </ng-container>

  <!-- Time Spent Column -->
  <ng-container matColumnDef="time_spent">
    <th mat-header-cell *matHeaderCellDef>
            <span
              i18n="Stats Dashboard|Exam time spent title@@stats-dashboard-exam-time-spent-title">Time spent:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="time-spent mat-body-2">
      <span *ngIf="element.timeSpent">{{formatTime(element.timeSpent)}}</span>
      <span *ngIf="!element.timeSpent">&mdash;</span>
    </td>
  </ng-container>

  <!-- Points Column -->
  <ng-container matColumnDef="points">
    <th mat-header-cell *matHeaderCellDef>
            <span
              i18n="Stats Dashboard|Exam Card Stats total points title@@stats-dashboard-exam-card-total-points-title">Total points:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="points mat-body-2">
      <span *ngIf="element.grade">{{element.points}}</span>
      <mat-icon *ngIf="!element.grade && element.type != statsTypes.user_part"
                matTooltip="count in progress"
                i18n-matTooltip="Stats Dashboard|Exam stats not ready title@@stats-dashboard-exam-stats-not-ready-title"
                class="color-orange">loop
      </mat-icon>
      <span *ngIf="!element.grade && element.type == statsTypes.user_part">&mdash;</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="mobileView ? mobileColumnsToDisplay : columnsToDisplay;"></tr>
  <tr mat-row *matRowDef="let element; columns: mobileView ? mobileColumnsToDisplay : columnsToDisplay;"
      class="question-answer-row"></tr>
</table>
